export default __webpack_public_path__ + "static/media/get-it-on-google-play.e9f2e738.svg";